import { actionComment } from '../utils/requests'

export const sendComment = (comment_post_ID, comment_parent, author, email, comment) => actionComment({
  comment_post_ID, comment_parent, author, email, comment,
})
